module.exports = __webpack_public_path__ + "img/active_over.b4e099e2.png";